import { ListItemButton, Box, Typography } from "@mui/material";
import { SelectionListItemProps } from "./SelectionListItem.types";
import { sxStyles } from "./SelectionListItem.styles";
import IMAGES from "lib/assets/images";
import Tags from "lib/components/tags/Tags";

const SelectionListItem = ({
  itemName,
  tagName,
  onClick,
}: SelectionListItemProps) => {
  const classes = sxStyles();
  return (
    <ListItemButton sx={classes.listItem} onMouseDown={onClick}>
      <Box sx={classes.button}>
        <Typography sx={classes.listTitle}>{itemName}</Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {tagName !== null && tagName !== "" && tagName !== undefined && (
            <Tags label={tagName} colorChoice="orange" />
          )}
          <Box component={"img"} src={IMAGES.general.ArrowForward} />
        </Box>
      </Box>
    </ListItemButton>
  );
};

export default SelectionListItem;
